<template class="tree-area">
        <div class="treeselect">
            <treeselect
                v-model="value"
                :max-height="250"
                :options="treeData"
                :default-expand-level="1"
                :always-open="alwaysOpen"
                :open-on-click="openOnClick"
                :load-options="handleOpenNode"
                :noOptionsText="$i18nUtil.trans('search.041')"
                :loadingText="$i18nUtil.trans('search.042')"
                :noChildrenText="$i18nUtil.trans('search.043')"
                @select="handleSelectNode"
            />
        </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH   } from '@riophae/vue-treeselect';
import Treeselect from '@riophae/vue-treeselect'

export default {
    components: {
        Treeselect
    },
    data() {
        return {
            /* Tree options */
            value: [],
            text: this.$i18nUtil.trans("message.GroupOrg.004","트리 데이터 로딩중.."),
            alwaysOpen: true,
            multipleYn: true,
            openOnClick: true, 

            /* Rest */
            url: null,
            method: null,
            req: {
                companyId: null,
                searchCondition: null,
                searchKeyword: null,
            },

            selectedNode:[],
            selectedNodeRoute:[],
            deleteindex:null,
        };
    },
    created() {
      this.getHtagManageAuth();
    },
    computed: {
        ...mapState("tree", ["treeData"]),
    },
    methods: {
      /* rest Call&CallBack Action */
      ...mapActions("restAction", ["COWORK_REST_ACTION"]),
      ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
      /* TreeData 등록 */
      ...mapActions("tree", ["setOrgTree"]),
      /* TreeData 변경&수정 */
      ...mapMutations("tree", ["resetTreeList"]),
      getHtagManageAuth(){
        let obj = this;
        let reqData = {
          url : "/api/copaper/tag/getHtagManageAuth",
          method : "post",
          params : {}
        };

        obj.COWORK_REST_SIMPLE_ACTION(reqData)
        .then(function (res) {
            if(res.errorCode == null){
              obj.getTreeData();
            }
        })
        .catch(function (err) {
          console.log(err);
        });
      },

      /* 최초 트리 데이터 조회 */
      getTreeData() {
        let area = document.getElementsByClassName("vue-treeselect__control");
        for (let i = 0; i < area.length; i++) {
          area[i].style.display = "none";
        }

        let obj = this;
        let reqData = {};
        reqData.req = obj.req;
        reqData.url = "/api/copaper/tag/getJobGroupList";
        reqData.method = "post";

        obj.COWORK_REST_ACTION(reqData)
        .then(function (data) {
          obj.resetTreeList(null);
          obj.req.searchKeyword = null;
          /* treeData set */
          let rootNode = data.result.rootJobGroup[0];
          let treeList = data.result.childJobGroups;

          obj.setOrgTree({
              rootNode: rootNode,
              treeList: treeList,
              parentNode: null,
          });
        })
        .catch(function (err) {
          console.log(err);
        });
      },
      /* 노드 오픈 */
      async handleOpenNode({ action, parentNode, callback }) {
        let node = event.target;
        this.observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            node.parentNode.classList.toggle('show');
            node.parentNode.parentNode.parentNode.classList.toggle('show');
          });
        });
        let config = {
          attributes: true, childList: true, characterData: true
        }
        this.observer.observe(node, config);
        let nodeList = [];
        if(action === LOAD_CHILDREN_OPTIONS ) {
          let obj = this;
          let reqData = {
            url : "/api/copaper/tag/getJobGroupList",
            method : "post",
            params : {
              htagCategoryId : parentNode.id,
            }
          };
          await obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if(res.errorCode !== null) {
              let errorCode = res.errorCode;
            } else {
              let treeList = res.result.childJobGroups;
            
              treeList.forEach(function(item, index, arr) {
                let node = item;
                let childYn = node.level;
                if(node.level == 3){
                  childYn = 0;
                }
                let nodeInfo = {
                  id: node.htagCategoryId,
                  label: node.htagCategoryName,
                  level: node.level
                };
                if (childYn > 0) {
                  nodeInfo.children = null;
                }
                nodeList.push(nodeInfo);
              });
            }
          })
          .catch(function (err) {
            console.log(err);
          });
          parentNode.children = nodeList;
        }
        // await this.$emit("openNode", { parentNode: parentNode, companyId: null });
      },
      /* 노드(부서) 선택 시 */
      handleSelectNode(node, instanceId) {
        // let returnData = this.selectedNodeRoute.some(function(data){
        //   if(node.level == data.level){
        //     return true;
        //   }
        // })

        // if(returnData){
        //   let jsonString = JSON.stringify(this.selectedNodeRoute);
        //   let changeNodeRoute = JSON.parse(jsonString);
        //   changeNodeRoute.some(function(data){
        //     if(data.level == node.level){
        //       data.id = node.id;
        //       data.label = node.label;
        //       return;
        //     }
        //   })
        //   this.selectedNodeRoute = changeNodeRoute;
        // }else{
        //   let jsonString = JSON.stringify(node);
        //   let addNodeRoute = JSON.parse(jsonString);
        //   this.selectedNodeRoute.push(addNodeRoute);
        // }

        // this.selectedNodeRoute.sort(function(a,b){
        //   return a.level - b.level;
        // })

        this.selectedNode=[];
        this.selectedNode.push(node); 
        this.$emit("selectNode", { node: node, instanceId: instanceId });
      },
      /* 노드 이름 수정 */
      handleChangeNodeName(selectedCategoryName){
        if(this.selectedNode != null){
          this.selectedNode[0].label = selectedCategoryName;
        }
      },
      /* 노드 추가. */
      handleAddNodeInfo(addHtagCategory){
        let selecteNodeId = this.selectedNode[0].id;
        let addNode = {
          id : addHtagCategory.htagCategoryId,
          label : addHtagCategory.htagCategoryName,
          level : addHtagCategory.level,
        }
        if(addHtagCategory.level < 3){
          addNode.children = null;
        }
          // children : null

        this.searchTreeData(this.treeData, selecteNodeId, addNode, "add");
      },
      /* 노드 삭제. */
      handledeleteNodeInfo(deleteHtagCategory){
        let selecteNodeId = this.selectedNode[0].id;
        let deleteNode = {
          id : deleteHtagCategory.htagCategoryId,
          label : deleteHtagCategory.htagCategoryName,
          level : deleteHtagCategory.level,
          children : null
        } 

        this.searchTreeData(this.treeData, selecteNodeId, deleteNode, "del");
      },
      searchTreeData(treeData, selecteNodeId, node, state){
        let obj =this;
        let returnData = treeData.some(function(data, idx){
          if(data.id == selecteNodeId){
            if(data.children != null){
              if(state === 'add'){
                data.children.push(node);
              } 
            }
            if(state === 'del'){
              treeData.splice(idx,1);
            }
            return true;
          }
          if(node.level > data.level && data.children != null){ 
            obj.searchTreeData(data.children, selecteNodeId, node, state); 
          }
        }) 
      }
    },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/HtagJobGroup.vue